import { Modal, Text, Stack, Avatar, Button, Card, Title } from "@mantine/core";
import { useState } from "react";
import { Beneficiary } from "../types";
import BeneficiaryDocs from "./BeneficiaryDocs";


interface Props {
  beneficiary: Beneficiary;
}

const CampaignBeneficiary = ({ beneficiary }: Props) => {
  const [opened, setOpened] = useState(false);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState<Beneficiary | null>(null);

  const openModal = (beneficiary: Beneficiary) => {
    setSelectedBeneficiary(beneficiary);
    setOpened(true);
  };

  return (
    <>
      {
        <Stack key={beneficiary.id} spacing="xs" mb="sm">
          <Text>Beneficiary Details</Text>
          <Avatar src={beneficiary.national_id_number} radius="xl" size="md" />
          <Text fw={600}>{beneficiary.name}</Text>
          <Button size="xs" onClick={() => openModal(beneficiary)}>View Details</Button>
        </Stack>
      }

   

      <Modal opened={opened} onClose={() => setOpened(false)} title="Beneficiary Details">
        {selectedBeneficiary && 
        <>
       {
       <>

       {
          (
            selectedBeneficiary.beneficiary_type=='self' &&(
              <Stack>
              <Text>Name: {selectedBeneficiary.first_name} {selectedBeneficiary.first_name}</Text>
              <Text>Email: {selectedBeneficiary.email}</Text>
              <Text>Mobile: {selectedBeneficiary.mobile_number}</Text>
              <Text>National ID: {selectedBeneficiary.national_id_number}</Text>
              <Text>Tax ID: {selectedBeneficiary.tax_id}</Text>
              <Text>Country: {selectedBeneficiary.country}</Text>
              <Text>City: {selectedBeneficiary.city}</Text>
              <Text>Preferred Payment: {selectedBeneficiary.prefered_payment_method}</Text>
              {
                (selectedBeneficiary.supportingDocuments) && 
                <>
                <Title>Supporting Documents</Title>
                <BeneficiaryDocs docs={selectedBeneficiary.supportingDocuments}/>
                </>
              }
            </Stack>
            )
  
            
  
  
            
          )
       }

{
          selectedBeneficiary.beneficiary_type=='other_person' &&(
            <Stack>
            <Text>Name: {selectedBeneficiary.first_name} {selectedBeneficiary.last_name}</Text>
            <Text>Email: {selectedBeneficiary.email}</Text>
            <Text>Mobile: {selectedBeneficiary.mobile_number}</Text>
            <Text>Country: {selectedBeneficiary.country}</Text>
            <Text>Tax ID: {selectedBeneficiary.tax_id}</Text>
            <Text>Relationship with fundraiser: {selectedBeneficiary.relationship_with_fundraiser}</Text>
            <Text>Preferred Payment: {selectedBeneficiary.prefered_payment_method}</Text>
            {
                (selectedBeneficiary.supportingDocuments) && 
                <>
                <Title>Supporting Documents</Title>
                <BeneficiaryDocs docs={selectedBeneficiary.supportingDocuments}/>
                </>
              }
          </Stack>
          )

          


          
       }

{
          selectedBeneficiary.beneficiary_type=='organization' &&(
            <Stack>
            <Text>Organization Name: {selectedBeneficiary.org_name}</Text>
            <Text>Organization Type: {selectedBeneficiary.org_type}</Text>
            <Text>Registration Number: {selectedBeneficiary.reg_number}</Text>
            <Text>Tax ID: {selectedBeneficiary.tax_id}</Text>
            <Text>Authorised Person Name: {selectedBeneficiary.authorized_person}</Text>
            <Text>Authorised Person Position: {selectedBeneficiary.authorized_position}</Text>
            <Text>Email: {selectedBeneficiary.email}</Text>
            <Text>Mobile: {selectedBeneficiary.mobile_number}</Text>
            <Text>Country: {selectedBeneficiary.country}</Text>
            <Text>Preferred Payment: {selectedBeneficiary.prefered_payment_method}</Text>
            {
                (selectedBeneficiary.supportingDocuments) && 
                <>
                <Title>Supporting Documents</Title>
                <BeneficiaryDocs docs={selectedBeneficiary.supportingDocuments}/>
                </>
              }
          </Stack>
          )

          


          
       }

{
          selectedBeneficiary.beneficiary_type=='community' &&(
            <Stack>
            <Text>Event Title: {selectedBeneficiary.event_title}</Text>
            <Text>Event Description: {selectedBeneficiary.event_description}</Text>
            <Text>Date: {selectedBeneficiary.event_date}</Text>
            <Text>Location: {selectedBeneficiary.event_location}</Text>
            <Text>City: {selectedBeneficiary.city}</Text>
            <Text>Country: {selectedBeneficiary.country}</Text>

            {
              selectedBeneficiary.is_funeral &&(
                <>
                <Text>Funeral Details</Text>
                <Text>Name of the Deceased: {selectedBeneficiary.deceased_person_name}</Text>
                <Card padding="md" shadow="sm">
                  <Card.Section>
                  <img crossOrigin="anonymous" src={`${selectedBeneficiary.the_deceased_photograph}`} height={300}/>
                  </Card.Section>
                </Card>
                <Text>Burial Date: {selectedBeneficiary.burial_date}</Text>
                <Text>Burial Date: {selectedBeneficiary.burial_location}</Text>
                <Text>Contact Phone: {selectedBeneficiary.event_organizer_phone}</Text>
                <Text>Contact Email: {selectedBeneficiary.event_organizer_email}</Text>
                {
                (selectedBeneficiary.supportingDocuments) && 
                <>
                <Title>Supporting Documents</Title>
                <BeneficiaryDocs docs={selectedBeneficiary.supportingDocuments}/>
                </>
              }
                </>
              )
            }
        
          </Stack>
          )

          


          
       }
       
       </>

        
       }
        </>
        }
      </Modal>
    </>
  );
};

export default CampaignBeneficiary;
